import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
import _imports_0 from '@/img/back.png';
import _imports_1 from '@/img/icon/filter-2.svg';
import _imports_2 from '@/img/icon/filter-1.svg';
import _imports_3 from '@/img/icon/arrow-right.svg';
const _hoisted_1 = {
  class: "tovar"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "tovar__inner"
};
const _hoisted_4 = {
  class: "tovar__content"
};
const _hoisted_5 = {
  key: 0,
  class: "tovar-wrapper"
};
const _hoisted_6 = {
  class: "tovar__left"
};
const _hoisted_7 = {
  class: "tovar__imgwrapper"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "back",
  class: "tovar-back"
}, null, -1);
const _hoisted_10 = {
  class: "tovar__filters"
};
const _hoisted_11 = {
  key: 0,
  class: "tovar__filter filter_1"
};
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "icon"
}, null, -1);
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "Вегеторианское", -1);
const _hoisted_14 = [_hoisted_12, _hoisted_13];
const _hoisted_15 = {
  key: 1,
  class: "tovar__filter filter_2"
};
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "icon"
}, null, -1);
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, "Острое", -1);
const _hoisted_18 = [_hoisted_16, _hoisted_17];
const _hoisted_19 = {
  class: "tovar__right"
};
const _hoisted_20 = {
  class: "tovar__tags"
};
const _hoisted_21 = {
  key: 0,
  class: "tovar__tag tovar__tag-hit"
};
const _hoisted_22 = {
  key: 1,
  class: "tovar__tag tovar__tag-new"
};
const _hoisted_23 = {
  class: "tovar__title"
};
const _hoisted_24 = {
  key: 0,
  class: "tovar-weight"
};
const _hoisted_25 = {
  key: 1,
  class: "tovar-weight"
};
const _hoisted_26 = {
  key: 2,
  class: "tovar-components"
};
const _hoisted_27 = {
  key: 3,
  class: "swiper-object-2"
};
const _hoisted_28 = {
  class: "tovar-components__imgwrapper"
};
const _hoisted_29 = ["src"];
const _hoisted_30 = {
  class: "tovar-components__text"
};
const _hoisted_31 = {
  class: "navigation"
};
const _hoisted_32 = {
  ref: "prev",
  class: "swiper-button-prev"
};
const _hoisted_33 = {
  ref: "next",
  class: "swiper-button-next"
};
const _hoisted_34 = {
  key: 4,
  class: "switch-box"
};
const _hoisted_35 = {
  class: "switch"
};
const _hoisted_36 = ["checked"];
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", {
  class: "round"
}, null, -1);
const _hoisted_38 = {
  class: "tovar__shop"
};
const _hoisted_39 = {
  class: "tovar__price"
};
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", null, "грн", -1);
const _hoisted_41 = ["src"];
const _hoisted_42 = ["src"];
const _hoisted_43 = ["disabled"];
const _hoisted_44 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "arrow"
}, null, -1);
const _hoisted_45 = [_hoisted_44];
const _hoisted_46 = ["disabled"];
const _hoisted_47 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "arrow"
}, null, -1);
const _hoisted_48 = [_hoisted_47];
const _hoisted_49 = {
  key: 1,
  class: "loader-box loader-slides"
};
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", {
  class: "loader"
}, null, -1);
const _hoisted_51 = [_hoisted_50];
const _hoisted_52 = {
  class: "tovar-slider__wrapper"
};
const _hoisted_53 = {
  class: "container"
};
const _hoisted_54 = {
  class: "tovar-slider__head"
};
const _hoisted_55 = /*#__PURE__*/_createElementVNode("h6", {
  class: "tovar-slider__title"
}, "Может, еще кое-что?", -1);
const _hoisted_56 = {
  class: "tovar-slider__count"
};
const _hoisted_57 = {
  key: 0,
  class: "loader-box loader-slides"
};
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", {
  class: "loader"
}, null, -1);
const _hoisted_59 = [_hoisted_58];
const _hoisted_60 = {
  class: "tovar-info"
};
const _hoisted_61 = {
  class: "container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Category = _resolveComponent("Category");
  const _component_Crumbs = _resolveComponent("Crumbs");
  const _component_swiper_slide = _resolveComponent("swiper-slide");
  const _component_swiper = _resolveComponent("swiper");
  const _component_SliderCategory = _resolveComponent("SliderCategory");
  const _component_InfoText = _resolveComponent("InfoText");
  const _directive_intersection = _resolveDirective("intersection");
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_Category, {
    class: "category"
  }), _createVNode(_component_Crumbs, {
    paths: $options.paths,
    class: "tovar-crumbs"
  }, null, 8, ["paths"]), _createElementVNode("div", _hoisted_4, [Object.keys(this.product).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
    class: "tovar__img",
    src: require(`@/img/products/${$setup.product.imgUrl}`),
    alt: "product"
  }, null, 8, _hoisted_8), _hoisted_9, _createElementVNode("div", _hoisted_10, [$setup.product.filter_2 ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14)) : _createCommentVNode("", true), $setup.product.filter_1 ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_18)) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [$setup.product.isHit ? (_openBlock(), _createElementBlock("p", _hoisted_21, "Hit")) : _createCommentVNode("", true), $setup.product.isNew ? (_openBlock(), _createElementBlock("p", _hoisted_22, "New")) : _createCommentVNode("", true)]), _createElementVNode("h1", _hoisted_23, _toDisplayString($setup.product.title), 1), $setup.product.weight ? (_openBlock(), _createElementBlock("p", _hoisted_24, " Вес: " + _toDisplayString($setup.product.weight) + "г ", 1)) : (_openBlock(), _createElementBlock("p", _hoisted_25, "Объем: " + _toDisplayString($setup.product.volume) + "л", 1)), $setup.product.weight ? (_openBlock(), _createElementBlock("p", _hoisted_26, "Состав:")) : _createCommentVNode("", true), $setup.product.weight ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createVNode(_component_swiper, {
    modules: $setup.modules,
    "slides-per-view": 5,
    "slides-per-group": 3,
    "space-between": 8,
    navigation: {
      prevEl: $setup.prev,
      nextEl: $setup.next
    },
    class: "tovar-slider"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.components, (slide, id) => {
      return _openBlock(), _createBlock(_component_swiper_slide, {
        key: id,
        class: "tovar-slider__slide"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_28, [$data.components.length > 0 ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "tovar-components__img",
          src: require(`@/img/ingredients/${slide.imgUrl}`),
          alt: "component"
        }, null, 8, _hoisted_29)) : _createCommentVNode("", true)]), _createElementVNode("p", _hoisted_30, _toDisplayString(slide.name), 1)]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }, 8, ["modules", "navigation"]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, null, 512), _createElementVNode("div", _hoisted_33, null, 512)])])) : _createCommentVNode("", true), $setup.product.weight ? (_openBlock(), _createElementBlock("label", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createElementVNode("input", {
    type: "checkbox",
    checked: $setup.product.filter_3
  }, null, 8, _hoisted_36), _hoisted_37]), _createTextVNode(" Безлактозное ")])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_38, [_createElementVNode("p", _hoisted_39, [_createTextVNode(_toDisplayString($setup.product.price), 1), _hoisted_40]), _createElementVNode("button", {
    class: _normalizeClass(["tovar__cart", {
      'is-added': $setup.product.isAdded
    }]),
    onClick: _cache[0] || (_cache[0] = $event => $setup.onClickAddPlus($setup.product, 'product'))
  }, [_createTextVNode(" В корзину "), _createElementVNode("img", {
    src: !$setup.product.isAdded ? require('@/img/icon/cart-green.svg') : require('@/img/icon/cart-white.svg'),
    alt: "cart"
  }, null, 8, _hoisted_41)], 2), _createElementVNode("button", {
    class: _normalizeClass(["tovar__favorite", {
      'is-favorite': $setup.product.isFavorite
    }]),
    onClick: _cache[1] || (_cache[1] = $event => (_ctx.addToFavorite($setup.product), $options.syncFavorite('product')))
  }, [_createElementVNode("img", {
    src: !$setup.product.isFavorite ? require('@/img/icon/heart-orange.svg') : require('@/img/icon/favorite-checked.svg'),
    alt: "heart"
  }, null, 8, _hoisted_42)], 2)])]), _createElementVNode("button", {
    class: "tovar__btn-prev",
    onClick: _cache[2] || (_cache[2] = $event => $options.onClickGoItem('prev')),
    disabled: $data.buttonDisabledPrev
  }, _hoisted_45, 8, _hoisted_43), _createElementVNode("button", {
    class: "tovar__btn-next",
    onClick: _cache[3] || (_cache[3] = $event => $options.onClickGoItem('next')),
    disabled: $data.buttonDisabledNext
  }, _hoisted_48, 8, _hoisted_46)])) : _createCommentVNode("", true), $data.isLoading ? (_openBlock(), _createElementBlock("div", _hoisted_49, _hoisted_51)) : _createCommentVNode("", true)])])])]), _createElementVNode("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_hoisted_55, _createElementVNode("div", _hoisted_56, _toDisplayString($data.pageNumber) + " из " + _toDisplayString($data.totalPagesSlide), 1)])]), _withDirectives(_createVNode(_component_SliderCategory, {
    slides: $setup.slidesTovar,
    pageNumber: $data.pageNumber,
    totalPages: $data.totalPagesSlide,
    onOnSlideChangePrev: _cache[4] || (_cache[4] = (direction, swiper) => $options.onSlideChange(direction, swiper)),
    onOnSlideChangeNext: _cache[5] || (_cache[5] = (direction, swiper) => $options.onSlideChange(direction, swiper)),
    onAddToFavorite: _cache[6] || (_cache[6] = item => {
      this.addToFavorite(item), $options.syncFavorite('slides', item);
    }),
    onAddToCart: _cache[7] || (_cache[7] = item => $setup.onClickAddPlus(item, 'slides'))
  }, null, 8, ["slides", "pageNumber", "totalPages"]), [[_directive_intersection, {
    active: () => $options.loadSlides()
  }]]), $data.isLoadingSlides ? (_openBlock(), _createElementBlock("div", _hoisted_57, _hoisted_59)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_createVNode(_component_InfoText, {
    class: "tovar-info"
  })])])]);
}